// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Sibling imports
const { INTEREST_FOLLOWING_CHANGE_PENDING } = require('./actions')

class InterestsFormInterestRecord extends Immutable.Record({
  followersCount: Number(),
  'profile_images': null,
  isFollowing: Boolean(),
  key: String(),
  name: String(),
  type: String(modelTypes.INTEREST)
}) {
  // No methods
}

InterestsFormInterestRecord.reviver = keyedReviver(InterestsFormInterestRecord, {
  // No nested data structures
})

InterestsFormInterestRecord.propTypes = {
  followersCount: PropTypes.number,
  'profile_images': PropTypes.arrayOf(PropTypes.string),
  isFollowing: PropTypes.oneOf([true, false, INTEREST_FOLLOWING_CHANGE_PENDING]),
  key: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // https://app.asana.com/0/857970715837912/928351645776875/f
  type: PropTypes.oneOf(['category', 'interest']).isRequired
}

module.exports = InterestsFormInterestRecord
